import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
// import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { adminGenerateKey } from "../../redux/actions/adminGenerateKeyAction";
// import { TramRounded } from "@mui/icons-material";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function AdminSetting() {
	const [generateKeyStatus, setGenerateKeyStatus] = useState(false);
	const [generateKeyArray, setGenerateKeyArray] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const partnerloginUser = useSelector(({ login }) => login);
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	// var authToken = partnerloginUser.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const generateKeyRes = useSelector(
		({ adminGenerateKey }) => adminGenerateKey
	);

	const generateKeyReq = () => {
		setIsLoading(true);
		setGenerateKeyStatus(true);
		let req = {
			loginDetails: {
				// adminId: "1"
				adminId: val.adminIDS
			}
		};
		dispatch(adminGenerateKey(req, authToken));
	};

	const generateKeyFunc = () => {
		if (generateKeyStatus) {
			if (generateKeyRes.data.status == "success") {
				setGenerateKeyArray(generateKeyRes.data);
				setIsLoading(false);
				setNotificationOpen(true);
			}
			if (generateKeyRes.data.status == "failed") {
				setGenerateKeyArray(generateKeyRes.data);
				setIsLoading(false);
				setNotificationOpen(true);
				if (
					generateKeyRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					generateKeyRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		generateKeyFunc();
	}, [generateKeyRes.data.status]);

	useEffect(() => {
		console.log(
			generateKeyArray,
			"//////////////////////////////////////////////////"
		);
	}, [generateKeyArray]);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	return (
		<>
			<Layout>
				{isLoading ? (
					<LoadingSpinner />
				) : !generateKeyArray.SKey ? (
					<Card style={{ borderLeft: "4px solid rgb(62 174 249)" }}>
						<p
							style={{
								fontSize: "1rem",
								// color: "#092058",
								padding: "16px 24px",
								margin: "0"
							}}
							className="generateKeyTextColor"
						>
							In order for your website to connect to the paymentz and perform
							successful transactions you would need to make adjustments to the
							scripts on your website.
						</p>
						<p
							style={{
								fontSize: "1rem",
								// color: "#092058",
								padding: "16px 24px",
								margin: "0"
							}}
							className="generateKeyTextColor"

						>
							The generated Key needs to be replaced with the old key on the
							checkout and redirect pages
						</p>
						<p
							style={{
								fontSize: "1rem",
								// color: "#092058",
								padding: "16px 24px",
								margin: "0"
							}}
							className="generateKeyTextColor"

						>
							Your current key : {partnerloginUser.data.SKey}
						</p>
						<div className="mx-auto pb-3">
							<CustomButton
								style={{
									padding: "8px",
									margin: "8px 8px"
								}}
								variant="contained"
								onClick={generateKeyReq}
							>
								Generate Key
							</CustomButton>
						</div>
					</Card>
				) : (
					<Card style={{ borderLeft: "4px solid rgb(62 174 249)" }}>
						<p
							style={{
								fontSize: "1rem",
								color: "#092058",
								padding: "16px 24px",
								margin: "0"
							}}
						>
							The key below is now your new key. Please use this key and make
							the changes in your integration code. Without these changes your
							web site will not connect with the null Payment Gateway Service.
							Please replace this key with the old key in the checkout and
							redirect pages.
						</p>
						<p
							style={{
								fontSize: "1rem",
								color: "#092058",
								padding: "16px 24px",
								margin: "0"
							}}
						>
							The generated key is highly confidential information and must not
							be shared to anyone including our system and support team. In case
							by any chance it has been shared to anyone, we suggest you to
							report to us and change it immediately.
						</p>
						<p
							style={{
								fontSize: "1rem",
								color: "#092058",
								padding: "16px 24px",
								margin: "0"
							}}
						>
							You are the owner of this secret key and to maintain its
							confidentiality is your responsibility and only you will be held
							responsible if it has been leaked and misused. We can't see this
							key or never ask to share this information to us or to anyone.
						</p>
						<div style={{ textAlign: "center" }} className="pb-3">
							<DialogTitle>Key Generated</DialogTitle>
							<input
								style={{ width: "70%", textAlign: "center", fontSize: "16px" }}
								disabled
								size="small"
								color="primary"
								type="text"
								name=""
								value={generateKeyArray.SKey}
							></input>
						</div>
					</Card>
				)}
			</Layout>
			{generateKeyArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{generateKeyArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{generateKeyArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{generateKeyArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default AdminSetting;
